/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import './getUrlParams';
// import { gsap } from "gsap";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// gsap.registerPlugin(ScrollSmoother);

function getUrlParams(url) {
  /* Source: https://www.sitepoint.com/get-url-parameters-with-javascript/ */

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {

        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string') {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }
  return obj;
}

export function support() {
  // Set up scroller
  // let smoother = ScrollSmoother.create({
  //   smooth: 1,
  //   effects: true,
  //   // smoothTouch: 0.1,
  //   normalizeScroll: true
  // });

  if (window.location.search) {
    // var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    var sectionTarget = getUrlParams()["section"];
    var formStatus = getUrlParams()["contact_posted"];
    $('.supportNav__item').removeClass('active');
    $('[data-support-target=' + sectionTarget + ']').addClass('active');

    $('.supportSection').removeClass('active');
    $('[data-support-id=' + sectionTarget + ']').addClass('active');

    if (formStatus == 'true') {
      $('[data-support-target=contact]').addClass('active');
      $('[data-support-id=contact]').addClass('active');
    }
  }

  $('.supportSection').hide();
  $('.supportSection.active').show();

  $('.supportNav__item').on('click tap', function () {
    var supportTarget = $(this).attr('data-support-target');
    if (history.pushState) {
      history.pushState(null, null, "?section=" + supportTarget);
    } else {
      location.search = "?section=" + supportTarget;
    }

    // Hide Support Sections
    $('.supportSection').hide().removeClass('active');

    // Show the targeted section
    $('.supportSection[data-support-id=' + supportTarget + ']').show().addClass('active');

    // // Scroll to top
    // gsap.to(smoother, {
    //   scrollTop: smoother.offset('.supportNav', "top top"),
    //   duration: 0.5
    // });


    $('.supportNav__item').removeClass('active');
    $(this).addClass('active');
    // Add URL Parameters
  });

}
